// Avatar image paths - centralized location for all avatar references
export const AVATARS = {
  PARENT_DEFAULT: '/avatars/parent-trex.svg',  // T-rex for anonymous parent
  CHILD_DEFAULT: '/avatars/child-dinosaur.svg',  // Sauropod for child
  PARENT_ANONYMOUS: '/avatars/parent-trex.svg', // Alias for consistency
};

// Helper function to get parent avatar
export const getParentAvatar = (currentUser) => {
  return currentUser?.photoURL || AVATARS.PARENT_DEFAULT;
};

// Helper function to get child avatar
export const getChildAvatar = () => {
  return AVATARS.CHILD_DEFAULT;
};

